import store from '@/state/store';
import authenticationSlice from '@/state/authentication.slice';
import { getProfile } from '@/api/profile';
import * as info from '@/api/info';
import api from '@/api/api';
import avatarLoader from '../user/avatar.loader';
import { handleError, setFeatures } from '@/actions/common';
import { startFetchCycle } from '../events';
import { ApiError } from '@bimdata/client';

async function fetchFeatures(): Promise<void> {
  let checkInterval: number | null = null;

  const fetcher = async (): Promise<boolean> => {
    try {
      const features = await info.features();
      setFeatures(features);
      if (checkInterval !== null) window.clearInterval(checkInterval);
      return true;
    } catch (error) {
      if (error instanceof ApiError && (error.code === 503)) {
        return false;
      }
      throw error;
    }
  }

  const done = await fetcher();
  if (!done) {
    checkInterval = window.setInterval(fetcher, 10000);
  }
}

export default async function (): Promise<void> {
  try {
    if (api.getSession()) {
      const profile = await getProfile();
      if (location.hash) {
        try {
          const hashParams = new URLSearchParams(location.hash.replace('#', ''));
          const redirect_url = hashParams.get("redirect_url");
          if (redirect_url) {
            location.assign(redirect_url);
            return;
          }
        } catch (e) {}
      }

      store.dispatch(authenticationSlice.actions.sessionChecked(profile));

      startFetchCycle();

      await fetchFeatures();

      await avatarLoader(profile);
    } else {
      store.dispatch(authenticationSlice.actions.sessionInvalid());
    }
  } catch (error) {
    handleError(error);
  }
};